"use client";

import dynamic from "next/dynamic";
import { ComponentType, FC, useEffect, useState } from "react";
import Conditional from "@repo/shared-ui/Conditional";
import useModalCloseOnBrowserButton from "@repo/shared-ui/useModalCloseOnBrowserButton";
import { getStockOverviewData } from "../../services/TradingMallService";
import { handleAboutStockReadmoreDL, handleCloseBtnDL } from "./AboutFunction";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";

const BFLModal: ComponentType<any> = dynamic(
  () => import("@repo/shared-ui/BFLModal") as any,
  { ssr: false },
);

interface AboutStockModalProps {
  exchId: string;
  formattedSymbol: string;
  title: string;
  readMoreText: string;
  buttonText: string;
}

const AboutStockModal: FC<AboutStockModalProps> = ({
  title,
  exchId,
  formattedSymbol,
  readMoreText,
  buttonText,
}) => {
  const loginStatus = useAppSelector(selectLoginStatus);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [desc, setDesc] = useState("");

  useEffect(() => {
    if (!isModalOpen) return;

    const fetchData = async () => {
      const aboutStockData = await getStockOverviewData({
        exchId,
        formattedSymbol,
      });
      setDesc(aboutStockData?.info?.desc || "");
    };

    fetchData();
  }, [isModalOpen, exchId, formattedSymbol]);

  const handleOpenModal = () => {
    handleAboutStockReadmoreDL(loginStatus, title, buttonText || "GOT IT");
    setIsModalOpen(true);
  };

  const handleModalClose = (btnClick = false) => {
    handleCloseBtnDL(loginStatus, title, buttonText || "GOT IT", btnClick);
    setIsModalOpen(false);
  };

  useModalCloseOnBrowserButton(isModalOpen, () => handleModalClose(false));

  return (
    <>
      <button className="cursor-pointer" onClick={handleOpenModal}>
        {readMoreText}
      </button>

      <Conditional if={isModalOpen}>
        <BFLModal
          data-testid="bfl-modal"
          isOpen={isModalOpen}
          onClose={() => handleModalClose(false)}
          title={title}
          buttonText={buttonText}
          onButtonClick={() => handleModalClose(true)}
        >
          <div
            className="text-gray-700"
            dangerouslySetInnerHTML={{ __html: desc }}
          />
        </BFLModal>
      </Conditional>
    </>
  );
};

export default AboutStockModal;
